import { ISettingsFields } from 'models/settings';
import * as actions from '../actions/settings';

const initialState: State = {
  settings: null,
  currentRouteTemplateId: null,
  currentAssignTemplateId: null,
};

export const reducer = (state: State = initialState, action: actions.SettingsTypes): State => {
  switch (action.type) {
    case actions.SettingsActions.SetSettings:
      return { ...state, settings: action.payload.settings };
    case actions.SettingsActions.UpdateSettings:
      return { ...state, settings: action.payload.settings };
    case actions.SettingsActions.SetRouteTemplate:
      return { ...state, currentRouteTemplateId: action.payload.routeTemplateId };
    case actions.SettingsActions.SetAssignTemplate:
      return { ...state, currentAssignTemplateId: action.payload.assignTemplateId };
    default:
      return state;
  }
};

export type State = {
  settings: ISettingsFields | null;
  currentRouteTemplateId: number | null;
  currentAssignTemplateId: number | null;
};
